var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgFacebook = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 160 160"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  opacity: 0,
  d: "M92.5 103.1h18.6l3.5-23.1H92.5V65c0-6.3 3.1-12.5 13-12.5h10.1V32.8c-5.9-1-11.9-1.5-17.9-1.6-18.3 0-30.2 11.1-30.2 31.1V80H47.2v23.1h20.3V159h.3c1.5.2 6.1.9 12.2.9 4.3 0 8.4-.3 12.5-1v-55.8z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#1877f2",
  d: "M80 0C35.8 0 0 35.8 0 80c0 39.9 29.3 73 67.5 79V103.1H47.2V80h20.3V62.4c0-20 11.9-31.1 30.2-31.1 6 .1 12 .6 17.9 1.6v19.7h-10.1c-9.9 0-13 6.2-13 12.5v15h22.2l-3.5 23.1H92.5V159c38.2-6 67.5-39.1 67.5-79 0-44.2-35.8-80-80-80z"
})));

export default SvgFacebook;